module.exports = __webpack_public_path__ + "static/media/prazdninove_chytani.8b35cd4d.jpg";